import React from "react";
import '../styles/style.css';
import { profile } from "../data/portfolio";

function Footer() {
    return (
        <footer id="footer">
            <p>{`© ${new Date().getFullYear()} ${profile.name}`}</p>
            <a href="#hero-section">Back to top</a>
        </footer>
    );
}

export default Footer;
